import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';

interface NotificationSettings {
  enabled: boolean;
  soundEnabled: boolean;
}

interface UserSettingsPageProps {
  hasOrcamentistaRole: boolean;
  notificationSettings: NotificationSettings;
  updateNotificationSettings: (updates: Partial<NotificationSettings>) => void;
}

export function UserSettingsPage({
  hasOrcamentistaRole,
  notificationSettings,
  updateNotificationSettings
}: UserSettingsPageProps) {
  return (
    <>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span>Minha Conta</span>
        <span>/</span>
        <span className="font-medium text-foreground">Configurações</span>
      </div>

      <Card className="shadow-sm">
        <CardHeader>
          <CardTitle>Minhas Configurações</CardTitle>
          <CardDescription>
            Configure suas preferências pessoais.
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-6">
          {hasOrcamentistaRole && (
            <div>
              <h3 className="text-lg font-semibold mb-4">Notificações de Novos Orçamentos</h3>
              <p className="text-sm text-muted-foreground mb-6">
                Configure como você deseja ser notificado quando um novo orçamento chega.
              </p>

              <div className="space-y-4">
                <div className="flex items-center justify-between gap-4">
                  <div className="space-y-1">
                    <Label>Notificações do Navegador</Label>
                    <p className="text-xs text-muted-foreground">
                      Receba notificações no navegador mesmo quando a aba não estiver ativa
                    </p>
                  </div>
                  <Switch
                    checked={notificationSettings.enabled}
                    onCheckedChange={(checked) => {
                      updateNotificationSettings({ enabled: checked });
                      if (checked && 'Notification' in window && Notification.permission === 'default') {
                        Notification.requestPermission();
                      }
                    }}
                  />
                </div>

                <div className="flex items-center justify-between gap-4">
                  <div className="space-y-1">
                    <Label>Alertas Sonoros</Label>
                    <p className="text-xs text-muted-foreground">
                      Reproduzir um som discreto quando um novo orçamento chegar
                    </p>
                  </div>
                  <Switch
                    checked={notificationSettings.soundEnabled}
                    onCheckedChange={(checked) => {
                      updateNotificationSettings({ soundEnabled: checked });
                    }}
                  />
                </div>

                {notificationSettings.enabled && 'Notification' in window && Notification.permission !== 'granted' && (
                  <div className="rounded-lg border border-orange-200 bg-orange-50 p-4 dark:border-orange-900 dark:bg-orange-950">
                    <p className="text-sm text-orange-700 dark:text-orange-300">
                      As notificações do navegador estão ativadas, mas você ainda não concedeu permissão.
                      Por favor, clique em "Permitir" quando o navegador solicitar.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
}
